import logService from '../../../services/wss/logService3';

/** Returns the number of journals the user currently has. */
export const getJournalUsed = (user) => {
    try {
        if (user === null) return 0;
        if (user.quota === null) return 0;
        return user.quota.length;
    } catch {
        return 0;
    }
};

/** Returns the maximum number of journals allowed for this user's tier. */
export const getJournalMax = (user) => {
    return null;
};

/** Returns the total number of entries across all journals. */
export const getEntries = (user) => {
    try {
        if (user === null) return 0;
        return user.quota.reduce((sum, x) => sum + x.total, 0);
    } catch {
        return 0;
    }
};

/** Returns the maximum number of entries allowed for this user's tier. */
export const getEntryMax = (user) => {
    try {
        if (user === null) return 0;
        return user.entryMax;
    } catch (error) {
        logService.logError(`accountHelpers.getEntryMax: error=${error.message}`);
        return 0;
    }
};
